/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActionItemInteractionRequest } from '../models/ActionItemInteractionRequest';
import type { InboxMarkAllNotificationsReadRequest } from '../models/InboxMarkAllNotificationsReadRequest';
import type { InboxMarkReadRequest } from '../models/InboxMarkReadRequest';
import type { SuccessResponse_ActionItemInteractionResponse_ } from '../models/SuccessResponse_ActionItemInteractionResponse_';
import type { SuccessResponse_InboxItemListResponse_ } from '../models/SuccessResponse_InboxItemListResponse_';
import type { SuccessResponse_InboxMarkReadResponse_ } from '../models/SuccessResponse_InboxMarkReadResponse_';
import type { SuccessResponse_InboxPublicReviewQueueResponse_ } from '../models/SuccessResponse_InboxPublicReviewQueueResponse_';
import type { SuccessResponse_InboxSummaryResponse_ } from '../models/SuccessResponse_InboxSummaryResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InboxService {
    /**
     * Get Inbox Summary Endpoint
     * GET /api/v1/inbox/summary — unified red-dot counts.
     * @returns SuccessResponse_InboxSummaryResponse_ Successful Response
     * @throws ApiError
     */
    public static getInboxSummaryEndpointApiV1InboxSummaryGet(): CancelablePromise<SuccessResponse_InboxSummaryResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inbox/summary',
        });
    }
    /**
     * List Inbox Items Endpoint
     * GET /api/v1/inbox/items — unified inbox list.
     * @returns SuccessResponse_InboxItemListResponse_ Successful Response
     * @throws ApiError
     */
    public static listInboxItemsEndpointApiV1InboxItemsGet({
        status = 'all',
        category,
        excludePublicReview = false,
        limit = 50,
        cursor,
        targetClient = 'miniprogram',
    }: {
        status?: 'all' | 'unread' | 'action_required' | 'notification' | 'todo' | 'waiting' | 'information' | 'completed',
        category?: (string | null),
        excludePublicReview?: boolean,
        limit?: number,
        cursor?: (string | null),
        targetClient?: 'miniprogram' | 'admin',
    }): CancelablePromise<SuccessResponse_InboxItemListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inbox/items',
            query: {
                'status': status,
                'category': category,
                'exclude_public_review': excludePublicReview,
                'limit': limit,
                'cursor': cursor,
                'target_client': targetClient,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Inbox Public Review Queue Endpoint
     * GET /api/v1/inbox/public-review-queue — 本人待处理公域差评的平台目录与队列页。
     * @returns SuccessResponse_InboxPublicReviewQueueResponse_ Successful Response
     * @throws ApiError
     */
    public static listInboxPublicReviewQueueEndpointApiV1InboxPublicReviewQueueGet({
        queueKey,
        limit = 20,
        cursor,
        targetClient = 'miniprogram',
    }: {
        queueKey?: (string | null),
        limit?: number,
        cursor?: (string | null),
        targetClient?: 'miniprogram' | 'admin',
    }): CancelablePromise<SuccessResponse_InboxPublicReviewQueueResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/inbox/public-review-queue',
            query: {
                'queue_key': queueKey,
                'limit': limit,
                'cursor': cursor,
                'target_client': targetClient,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Record Action Item Interaction Endpoint
     * Record an explicit open or registered-deep-link failure for one's own item.
     * @returns SuccessResponse_ActionItemInteractionResponse_ Successful Response
     * @throws ApiError
     */
    public static recordActionItemInteractionEndpointApiV1InboxActionItemsInteractionsPost({
        requestBody,
    }: {
        requestBody: ActionItemInteractionRequest,
    }): CancelablePromise<SuccessResponse_ActionItemInteractionResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inbox/action-items/interactions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Mark Inbox Read Endpoint
     * POST /api/v1/inbox/read — mark visible inbox items as read.
     * @returns SuccessResponse_InboxMarkReadResponse_ Successful Response
     * @throws ApiError
     */
    public static markInboxReadEndpointApiV1InboxReadPost({
        requestBody,
    }: {
        requestBody: InboxMarkReadRequest,
    }): CancelablePromise<SuccessResponse_InboxMarkReadResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inbox/read',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Mark All Inbox Notifications Read Endpoint
     * Mark all visible notifications read; actionable work remains actionable.
     * @returns SuccessResponse_InboxMarkReadResponse_ Successful Response
     * @throws ApiError
     */
    public static markAllInboxNotificationsReadEndpointApiV1InboxNotificationsReadAllPost({
        requestBody,
    }: {
        requestBody: InboxMarkAllNotificationsReadRequest,
    }): CancelablePromise<SuccessResponse_InboxMarkReadResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/inbox/notifications/read-all',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
